"use client"

import { Baby } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BabyIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BabyIcon = component(Icon)({ as: Baby })
